module.exports = __webpack_public_path__ + "static/img/3-info-b4.d911899.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/3-info-b4.jpg
// module id = PzVH
// module chunks = 0